import { Head, useForm, Link } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Mail, ArrowLeft, CheckCircle2, AlertCircle } from "lucide-react";

interface Props {
  error?: string;
  notice?: string;
}

export default function ForgotPassword({ error, notice }: Props) {
  const { data, setData, post, processing, errors } = useForm({
    user: {
      email: "",
    },
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    post("/users/password");
  };

  return (
    <>
      <Head title="Forgot Password - CFS Dashboard" />

      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-950 dark:to-slate-900 p-4">
        <div className="w-full max-w-md space-y-8">
          {/* Logo and Title */}
          <div className="text-center">
            <div className="flex justify-center mb-4">
              {/* <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl flex items-center justify-center shadow-lg">
                <span className="text-2xl font-bold text-white">CFS</span>
              </div> */}
            </div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
              Forgot your password?
            </h1>
            {/* <p className="mt-2 text-gray-600 dark:text-gray-400">
              No worries, we'll send you reset instructions
            </p> */}
          </div>

          {/* Reset Card */}
          <Card className="border-0">
            {/* <CardHeader className="space-y-1"> */}
            {/* <CardTitle className="text-2xl text-center">
                Password Reset
              </CardTitle> */}
            {/* <CardDescription className="text-center">
                Enter your email address and we'll send you a link to reset your
                password
              </CardDescription> */}
            {/* </CardHeader> */}

            <form onSubmit={handleSubmit}>
              <CardContent className="space-y-4">
                {/* Success Alert */}
                {notice && (
                  <Alert className="border-green-200 bg-green-50 dark:bg-green-950/20">
                    <CheckCircle2 className="h-4 w-4 text-green-600" />
                    <AlertDescription className="text-green-800 dark:text-green-200">
                      {notice}
                    </AlertDescription>
                  </Alert>
                )}

                {/* Error Alert */}
                {(error || errors.email) && (
                  <Alert variant="destructive">
                    <AlertCircle className="h-4 w-4" />
                    <AlertDescription>{error || errors.email}</AlertDescription>
                  </Alert>
                )}

                {/* Email Field */}
                <div className="space-y-2">
                  <Label htmlFor="email" className="text-sm font-medium">
                    Email address
                  </Label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                    <Input
                      id="email"
                      type="email"
                      placeholder="user@emailresolute.com"
                      value={data.user.email}
                      onChange={(e) => setData("user.email", e.target.value)}
                      className="pl-10 h-11"
                      required
                      autoComplete="email"
                    />
                  </div>
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                    We'll send a password reset link to this email address
                  </p>
                </div>
              </CardContent>

              <CardFooter className="flex flex-col space-y-4 pt-2 mt-4">
                <Button
                  type="submit"
                  className="w-full h-11 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800"
                  disabled={processing}
                >
                  {processing ? "Sending..." : "Send Reset Link"}
                </Button>

                {/* <Link
                  href="/users/sign_in"
                  className="flex items-center justify-center gap-2 text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100 transition-colors"
                >
                  <ArrowLeft className="h-4 w-4" />
                  Back to login
                </Link> */}
              </CardFooter>
            </form>
          </Card>

          {/* Footer */}
          <p className="text-center text-xs text-gray-500 dark:text-gray-400">
            Remember your password?{" "}
            <Link
              href="/users/sign_in"
              className="underline hover:text-gray-700 dark:hover:text-gray-300"
            >
              Sign in here
            </Link>
          </p>
        </div>
      </div>
    </>
  );
}
